import { useMemo } from 'react';
import { Group } from '@thive/fddm-types';

import { useAppStore } from '@modules/app/store/useAppStore';

import { useFloorplanDesignStore } from '../store/useFloorplanDesignStore';

export const useReadSelectedGroups = (): Group[] => {
  const ids = useAppStore((state) => state.selectedIds);
  const { groups } = useFloorplanDesignStore((state) => state.uxonly);
  return useMemo(() => groups.filter((group) => ids.includes(group.id)), [groups, ids]);
};
